// extracted by mini-css-extract-plugin
module.exports = {"button_delete":"styles_button_delete__CjKm-"};